<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/il1wCJ/tc-custom/9780547563893.jpg?1736952367146" alt="This image is the cover for the book Island of the Day Before"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Island of the Day Before
      </h1>
      <p class="bookDescription body article font2">
        <b>A 17th century Italian nobleman is marooned on an empty ship in this “astonishing intellectual journey" by the author of <i>Foucault’s Pendulum</i> (<i>San Francisco Chronicle</i>).</b><br/>  <br/> In the year 1643, a violent storm in the South Pacific leaves Roberto della Griva shipwrecked—on a ship. Swept from the <i>Amaryllis</i>, he has managed to pull himself aboard the <i>Daphne</i>, anchored in the bay of a beautiful island. The ship is fully provisioned, he discovers, but the crew is missing.<br/><br/> As Roberto explores the different cabinets in the hold, he looks back on various episodes from his life: Ferrante, his imaginary evil brother; the siege of Casale, that meaningless chess move in the Thirty Years' War in which he lost his father and his illusions; and the lessons given him on Reasons of State, fencing, the writing of love letters, and blasphemy.<br/><br/> In this “intellectually stimulating and dramatically intriguing” novel, Umberto Eco conjures a young dreamer searching for love and meaning; and an old Jesuit who, with his clocks and maps, has plumbed the secrets of longitudes, the four moons of Jupiter, and the Flood (<i>Chicago Tribune</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Umberto Eco
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e499c73